import React from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: '01',
  title: 'Fundamentos de Biodescodificación',
  desc: 'El origen, la historia y los principios del método. Cómo funciona el vínculo entre emoción y biología. Los principios bio que cambian tu mirada sobre el síntoma.'
}, {
  num: '02',
  title: 'El Mapa del Síntoma',
  desc: 'Los sistemas del cuerpo y su emocionalidad. Cómo interpretar lateralidad, ubicación y tiempo del síntoma. Incluye diccionario bio de síntomas.'
}, {
  num: '03',
  title: 'Transgeneracional y Árbol Bio',
  desc: 'El sistema completo de árbol genealógico bio. Patrones familiares, lealtades y conflictos repetitivos generación tras generación.'
}, {
  num: '04',
  title: 'Protocolos de Sesión',
  desc: 'El protocolo más completo de sesión bio. Paso a paso exacto para conducir, integrar y cerrar sesiones con seguridad.'
}, {
  num: '05',
  title: 'Casos Clínicos Reales',
  desc: 'Más de 20 casos analizados paso a paso para comprender cómo se aplica el método en situaciones reales.'
}, {
  num: '06',
  title: 'Tu Consultorio Holístico Profesional',
  desc: 'Cómo transformar tu práctica en una actividad profesional. Clientes, redes sociales, sesiones online y organización profesional.'
}];
export function SystemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#E8E0D3] py-5 md:py-10 px-5 sm:px-6 border-t border-[#2E4F48]/5" data-id="element-179">
      <div className="container mx-auto max-w-5xl" data-id="element-180">
        <div ref={ref1} className={`reveal text-center mb-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-181">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#1C3B36] mb-4" data-id="element-182">
            Formación completa organizada en 6 tomos profesionales
          </h2>
          <p className="text-[#44574F] text-base md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-183">
            Una estructura diseñada para avanzar paso a paso desde los
            fundamentos hasta la aplicación práctica y profesional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-184">
          {TOMOS.map((tomo, i) => {
          const [ref, vis] = useReveal();
          return <div key={i} ref={ref} className={`reveal bg-[#ffffff] border border-[#2E4F48]/20 rounded-xl p-6 transition-all hover:border-[#44574F]/60 hover:shadow-lg shadow-sm flex gap-5 ${vis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 60}ms`
          }} data-id="element-185">
                <div className="flex-shrink-0" data-id="element-186">
                  <div className="w-14 h-14 rounded-full bg-[#2E4F48] flex items-center justify-center border-2 border-[#C2683D]/40" data-id="element-187">
                    <span className="text-[#E8E0D3] font-serif font-bold text-lg" data-id="element-188">
                      {tomo.num}
                    </span>
                  </div>
                </div>
                <div className="flex-1" data-id="element-189">
                  <h3 className="text-[#1C3B36] font-serif font-bold text-xl mb-2 leading-tight" data-id="element-190">
                    {tomo.title}
                  </h3>
                  <p className="text-[#1C3B36] text-sm leading-relaxed" data-id="element-191">
                    {tomo.desc}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}